import type { Addon, AddonGroup } from '~/models';

const useAddon = (group: AddonGroup) => {
  const getTotal = (group: AddonGroup): number => {
    return group.addons
      .map(({ quantity, freeQuantity, price }) => {
        return (quantity - freeQuantity) * price;
      })
      .reduce((acc, curr) => acc + curr, 0);
  };

  const add = (addon: Addon): void => {
    try {
      if (group.maxChoices <= 1) {
        group.addons.forEach((item) => {
          item.quantity = 0;
          item.selected = false;
        });

        addon.selected = true;
        addon.quantity = 1;
        return;
      }

      const choices = group.addons
        .map(({ quantity }) => quantity)
        .reduce((acc, curr) => acc + curr, 0);

      if (group.maxChoices === choices) {
        return;
      }

      addon.selected = true;
      addon.quantity++;

      const freeChoices = group.addons
        .map(({ freeQuantity }) => freeQuantity)
        .reduce((acc, curr) => acc + curr, 0);

      if (group.freeAmount === freeChoices) {
        return;
      }

      addon.freeQuantity = addon.freeQuantity + 1;
    } finally {
      group.total = getTotal(group);
    }
  };

  const remove = (addon: Addon): void => {
    try {
      addon.quantity--;

      if (addon.freeQuantity > addon.quantity) {
        addon.freeQuantity--;
      }

      if (addon.quantity === 0) {
        addon.selected = false;
      }
    } finally {
      group.total = getTotal(group);
    }
  };

  return {
    add,
    remove
  };
};

export { useAddon };
